// Hooks / Node modules / Styles

// Reducers / Actions

// Utils / Functions

// Components
import DefaultLayout from "src/layout/standard/primary/DefaultLayout";

// Sub-Components

// Data / Images / Icons

function P_Medium() {
  return (
    <DefaultLayout>P_Medium</DefaultLayout>
  )
}

export default P_Medium